/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type PublishStatus = (typeof PublishStatus)[keyof typeof PublishStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublishStatus = {
  DRAFT: 'DRAFT',
  PUBLISHED: 'PUBLISHED',
  ARCHIVED: 'ARCHIVED',
} as const
